import { lazy } from "react";
import NotFoundPage from "~/components/not-found";
import ReviewsPromotionPage from "~/components/PromoReviewsPro/PromotionPage";
import { app, fullscreen } from "~/helpers/routes";
import { paths } from "~/router/paths";

const Dashboard = lazy(() => import("~/pages/dashboard"));
const WinningAds = lazy(() => import("~/pages/winning-ads"));
const HomePage = lazy(() => import("~/pages/home"));
const WinningProducts = lazy(() => import("~/pages/winning-products"));
const UsEuProducts = lazy(() => import("~/pages/us-eu-products"));
const OrdersPage = lazy(() => import("~/pages/orders"));
const ImportListPage = lazy(() => import("~/pages/import-list"));
const LiveProductsPage = lazy(() => import("~/pages/live-products"));
const BrandedInvoice = lazy(() => import("~/pages/branded-invoice"));
const ProductAnalyzer = lazy(() => import("~/pages/product-analyzer"));
const CancelationPage = lazy(() => import("~/pages/cancel"));

export const routes: Array<any> = [
  {
    path: paths.app.home,
    element: app(Dashboard),
  },
  {
    path: paths.app.winningAds,
    element: app(WinningAds),
  },
  {
    path: paths.app.aliexpressProducts,
    element: app(HomePage),
  },
  {
    path: paths.app.winningProducts,
    element: app(WinningProducts),
  },
  {
    path: paths.app.usEuProducts,
    element: app(UsEuProducts),
  },
  {
    path: paths.app.orders,
    element: app(OrdersPage, paths.app.orders),
  },
  {
    path: paths.app.sampleOrders,
    element: app(OrdersPage, paths.app.sampleOrders),
  },
  {
    path: paths.app.importList,
    element: app(ImportListPage),
  },
  {
    path: paths.app.liveProducts,
    element: app(LiveProductsPage),
  },
  {
    path: paths.app.promoReviews,
    element: app(ReviewsPromotionPage),
  },
  {
    path: paths.app.brandedInvoice,
    element: app(BrandedInvoice),
  },
  {
    path: paths.app.productAnalyzer,
    element: app(ProductAnalyzer),
  },
  {
    path: paths.app.cancel,
    element: fullscreen(CancelationPage),
  },
  {
    path: paths.app.notFound,
    element: app(NotFoundPage),
  },
];
